<template>
	<div class="container">
		<!--  顶部  -->
		<div class="header-box g-flex g-row-center" style="align-items: stretch;">
			<div class="total-width g-rela">
				<!--  门店信息  -->
				<div class="g-flex g-m-l-40 g-col-top g-m-t-50">
					<div class="white-bg">
						<img :src="hospital.avatar?hospital.avatar:require('@/assets/examples/02.png')"
							class="store-img" alt="">
					</div>
					<div class="g-m-l-30 g-m-t-10">
						<div class="g-flex">
							<p class="white-text g-font-28 g-weight-font">{{hospital.name}}</p>
							<p class="store-tag g-font-12" v-if="hospital.gradeName">{{hospital.gradeName}}</p>
						</div>
						<div class="g-m-t-12 position-tag">
							<span class="white-text">在招职位：</span>
							<span class="yellow-text">{{total}}个</span>
						</div>
					</div>
				</div>
				<!--  tab  -->
				<div class="header-tab pointer tab1" @click="changeTab(1)" :class="{'active-tag':tabIndex === 1}">
					在招职位（{{total}}）
				</div>
				<div class="header-tab pointer tab2" @click="changeTab(2)" :class="{'active-tag':tabIndex === 2}">
					公司简介
				</div>
			</div>
		</div>

		<!--  在招职位/公司简介  -->
		<div class="g-flex g-row-center">
			<!--  在招职位  -->
			<div class="total-width g-m-t-20" v-show="tabIndex === 1">
				<!--  列表  -->
				<div class="g-m-b-15 job-item" v-for="(item,index) in jobList" :key="index">
					<find-job-card @showResume="showResume" :item="item"></find-job-card>
				</div>
				<!--  分页  -->
				<div class="g-flex g-row-center g-m-t-30">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="params.current" :page-sizes="[10, 20, 30, 40]" :page-size="params.size"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
			<!--  公司简介  -->
			<div class="total-width g-m-t-20" v-show="tabIndex === 2">
				<div class="info-box">
					<div class="total-tag g-m-t-30">
						<div class="g-flex">
							<img src="@/assets/find-job/half-circle.png" class="half-circle" alt="">
							<p class="g-m-l-5 white-text g-font-20 g-weight-font">公司信息</p>
						</div>
					</div>
					<div class="g-m-t-20 g-m-l-30 g-m-r-30 remark-text g-font-16">
						{{hospital.brief}}
					</div>

					<div class="total-tag g-m-t-50">
						<div class="g-flex">
							<img src="@/assets/find-job/half-circle.png" class="half-circle" alt="">
							<p class="g-m-l-5 white-text g-font-20 g-weight-font">公司环境</p>
						</div>
					</div>
					<div class="g-m-t-20 g-m-l-20 g-m-r-20">
						<!--  公司图片固定五张  -->
						<div class="photo-box g-flex g-row-between">
							<img :src="item" class="company-img" v-for="(item,index) in hospital.interiorImages" :key="index">
						</div>
					</div>

					<div class="total-tag g-m-t-50">
						<div class="g-flex">
							<img src="@/assets/find-job/half-circle.png" class="half-circle" alt="">
							<p class="g-m-l-5 white-text g-font-20 g-weight-font">工作地址</p>
						</div>
					</div>
					<div class="g-p-35">
						<div class="map-box">
							<div class="g-p-15 g-flex">
								<img src="@/assets/find-job/position-icon.png" class="position-icon" alt="">
								<p class="g-m-l-10 g-font-16">{{hospital.address}}</p>
							</div>
							<div class="g-p-20">
								<div class="map-container" id="map" style="width: 100%;"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--  投递简历弹窗  -->
		<message-popup ref="popup" :showCancel="false" confirmText="知道了" @submit="doSubmit">
			<div class="g-text-center">
				<p class="g-m-t-10 main-text g-font-20">投递成功了!</p>
				<p class="g-m-t-20 remark-text g-font-14">已成功为您投递简历，请留意站内消息。</p>
			</div>
		</message-popup>
	</div>
</template>

<script>
	import {
		TMap
	} from '@/utils/TMap'
	import FindJobCard from "@/views/find-job/components/find-job-card";
	import messagePopup from "@/components/message-popup";
	import {
		jobList,
		jobDetail,
		hospitalDetail
	} from "@/api/job.js"
	import {dictDetail} from "@/api/api.js"
	export default {
		name: "store-detail",
		components: {
			FindJobCard,
			messagePopup
		},
		data() {
			return {
				id: '',
				hospital: {},
				jobList: [],
				tabIndex: 1,
				currentPage: 1,
				TMap: null,
				mapKey: 'VCLBZ-MGTL3-FXJ3U-3J5Q4-VMOH7-PZBO4',
				total: 0,
				params: {
					current: 1,
					size: 10,
					clinicId: ''
				},
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.params.clinicId = this.id
			
			this.getDetail()
			this.getJobList()
			
		},
		methods: {
			getDetail() {
				hospitalDetail({
					id: this.id
				}).then(res => {
					this.hospital = res
					this.hospital.interiorImages = this.hospital.interiorImages.split(',')
					this.getGradeName();
					this.initMap(res.latitude, res.longitude);
					
				})
			},
			getGradeName(){
				if(this.hospital.grade){
					dictDetail({code:'grade',dictKey:this.hospital.grade}).then(res=>{
						let gradeName = res.dictValue || this.hospital.grade;
						this.$set(this.hospital,'gradeName',gradeName);
					})
				} else {
					this.$set(this.hospital,'gradeName','');
				}
				
			},
			getJobList() {
				jobList(
					this.params
				).then(res => {

					this.jobList = res.records
					this.total = res.total
				})
			},
			initMap(lat, lng) {
				TMap(this.mapKey).then(qq => {
					let center = new qq.maps.LatLng(lat, lng);
					let map = new qq.maps.Map(document.getElementById("map"), {
						// 地图的中心地理坐标
						center: center,
						//初始化地图缩放级别
						zoom: 15
					});
					//添加提示窗
					let infoWin = new qq.maps.InfoWindow({
						map: map
					});
					//添加标记
					let marker = new qq.maps.Marker({
						position: center,
						map: map,
					})

				})
			},
			// 页数切换
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.params.size = val;
				this.getJobList()
			},
			// 当前页切换
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.params.current = val;
				this.getJobList()
			},
			// 打开投递简历弹窗
			showResume(e) {
				console.log(e)
				//todo...

				this.$refs.popup.open()
			},
			// 投递简历确定事件
			doSubmit() {
				this.$refs.popup.close()
			},
			// tab切换
			changeTab(val) {
				this.tabIndex = val
				if (val === 2) {
					this.$nextTick(() => {
						
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.header-box {
		background-image: url("../../assets/find-job/store-top-bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		width: 100%;
		height: 240px;

		.white-bg {
			background: #fff;
			padding: 4px;
			border-radius: 5px;
		}

		.store-img {
			width: 104px;
			height: 104px;
		}

		.store-tag {
			background: #eea906;
			border-radius: 5px;
			padding: 3px 12px;
			color: #fff;
			margin-left: 15px;
		}
	}

	.position-tag {
		background: rgba(255, 255, 255, 0.20);
		border-radius: 5px;
		padding: 3px 12px;
		display: inline-block;
	}

	.header-tab {
		padding: 10px 30px;
		border-radius: 20px 20px 0 0;
		position: absolute;
		background: rgba(255, 255, 255, 0.10);
		color: #fff;
		bottom: 0;

		&:hover {
			background: #fff;
			color: #407aff;
			transition: all ease-in 0.2s;
		}
	}

	.tab1 {
		left: 40px;
	}

	.tab2 {
		left: 240px;
		padding: 10px 50px;
	}

	.active-tag {
		background: rgba(255, 255, 255, 0.60);
		color: #407aff;
	}

	.job-item {
		width: 1200px;
	}

	.info-box {
		background: #ffffff;
		border-radius: 5px;
	}


	.total-tag {
		padding: 3px 15px 3px 20px;
		border-radius: 0 20px 20px 0;
		color: #fff;
		background: #407aff;
		display: inline-block;

		.half-circle {
			width: 10px;
			height: 18px;
		}
	}

	.photo-box {
		background: #f6f6f8;
		border-radius: 5px;
		padding: 20px;

		.company-img {
			width: 210px;
			height: 165px;
			border-radius: 5px;
			margin-right: 15px;
		}
	}

	.map-box {
		background: #ffffff;
		border-radius: 5px;
		box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);

		.map-container {
			width: 100%;
			height: 285px;
		}
	}
</style>
